import React, { FC } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import styles from '../CustomModal/CustomModal.module.scss';

interface CustomModalProps {
    isActive?: boolean;
    children: any;
    title?: string;
    handleClose: any;
    showClose?: boolean;
}

const CustomModal: FC<CustomModalProps> = ({ isActive, children, title, handleClose, showClose = true }) => {
    const fullWidth = true;
    const maxWidth = 'sm';
    return (
        <Dialog
            fullWidth={fullWidth}
            maxWidth={maxWidth}
            onClose={handleClose}
            className={styles.CustomModal}
            open={isActive || false}
        >
            <DialogTitle>{title}</DialogTitle>
            {
                showClose &&
                <IconButton
                    className={styles.CloseAction}
                    aria-label="close"
                    onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
            }
            <DialogContent onClick={event => event.stopPropagation()}>
                {children}
            </DialogContent>
        </Dialog>
    );
};

export default CustomModal;
